/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Box } from '@mui/system';
import { MessageBody } from '@sendbird/uikit-react/ui/MessageContent';
// eslint-disable-next-line import/no-unresolved
import { MessageBodyProps } from '@sendbird/uikit-react/types/ui/MessageContent/MessageBody';

import useMessageNavigation from '../../../../hooks/Chat/useMessageNavigation';

import styles from './styles';

// A MESSAGE THAT CARRIES A DESTINATION BEHAVES AS A LINK TO IT
const NavigationMessageBody = (props: MessageBodyProps) => {
  const { message } = props;

  const {
    isNavigable,
    handleOpenNavigation,
    handleNavigationKeyDown,
  } = useMessageNavigation(message);

  if (!isNavigable) {
    return <MessageBody {...props} />;
  }

  return (
    <Box
      role="link"
      tabIndex={0}
      sx={styles.navigationLink}
      onClick={handleOpenNavigation}
      onKeyDown={handleNavigationKeyDown}
    >
      <MessageBody {...props} />
    </Box>
  );
};

export default NavigationMessageBody;
